'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

var _utils = require('../../utils');

var _winresShoppingCart = require('../winresShoppingCart/winresShoppingCart');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var log = (0, _utils.getLog)('[Summary]');

// Reservation summary BEFORE payment, i.e. shows the reservation session, not
// the contents of a Winres reservation object.

var WinresReservationSummaryController = function () {
    function WinresReservationSummaryController($scope, $document, $filter, userService, $rootScope, localizationService, messageService, cancelService, discountService) {
        _classCallCheck(this, WinresReservationSummaryController);

        $scope._ = _;
        this.$scope = $scope;
        this.$document = $document;
        this.$filter = $filter;
        this.messageToBooking = "";
        this.unpaidTotal = 0;
        this.paidTotal = 0;
        this.userService = userService;
        this.user = userService.getCurrentUser();
        this.$scope.summaryInfo = null;
        this.$scope.summaryInfoHeader = null;
        this.$rootScope = $rootScope;
        this.localizationService = localizationService;
        this.messageService = messageService;
        this.cancelService = cancelService;
        this.discountService = discountService;
    }

    _createClass(WinresReservationSummaryController, [{
        key: '$onInit',
        value: function $onInit() {
            var _this = this;

            // Dependencies
            // this.winresReservationContext

            // Get:
            // getContext()
            // getContext().Destination
            // getContext().SelectedDeparture
            // getContext().Products
            // getConfirmBookingResult()

            // Set:
            // setMessageToBooking()

            this.data = this.winresReservationContext.getContext();
            // log("Data is:", this.data);

            this.language = this.localizationService.getLanguage();

            // Check travel package
            this.$scope.$watch(function () {
                return _this.data.Products;
            }, function () {
                return _this.checkTravelPackageMessage();
            }, true);

            this.getMessageHeader();
            this.messageCode = this.messageCode || 'WRCNOT';

            this.confirmBookingResult = this.winresReservationContext.getConfirmBookingResult();
            this.$scope.$on('confirmBooking', function () {
                // log("'confirmBooking' received!");
                _this.confirmBookingResult = _this.winresReservationContext.getConfirmBookingResult();
                log("BookingResult is:", _this.confirmBookingResult);
            });

            this.$scope.$watch('$ctrl.messageToBooking', function () {
                _this.winresReservationContext.setMessageToBooking(_this.messageToBooking);
            });
            this.$scope.$watch('$ctrl.data.Destination', function () {
                _this.Destination = _this.data.Destination;
            });

            this.$scope.$watch('$ctrl.winresReservationContext.context.selectedReservation.BookingNumber', function () {});

            this.$scope.$watch('$ctrl.data.SelectedDeparture', function () {
                _this.Departure = _this.data.SelectedDeparture;

                if (!_this.Departure) {
                    _this.DepartureTime = null;
                    _this.ArrivalTime = null;
                    return;
                }

                var depTime1 = moment(_this.Departure.DepartureTime, 'HH:mm');
                var arrTime1 = moment(_this.Departure.ArrivalTime, 'HH:mm');

                if (!depTime1.isValid()) log.warn("Departure.DepartureTime2 is not valid:", _this.Departure.DepartureTime);
                if (!arrTime1.isValid()) log.warn("Departure.ArrivalTime2 is not valid:", _this.Departure.ArrivalTime);

                if (depTime1.isValid() && arrTime1.isValid() && (depTime1.hours() > 0 || depTime1.minutes() > 0 || arrTime1.hours() > 0 || arrTime1.minutes() > 0)) _this.DepartureTime = _this.Departure.DepartureTime + "-" + _this.Departure.ArrivalTime;

                var depTime2 = moment(_this.Departure.DepartureTime2, 'HH:mm');
                var arrTime2 = moment(_this.Departure.ArrivalTime2, 'HH:mm');

                if (!depTime2.isValid()) log.warn("Departure.DepartureTime2 is not valid:", _this.Departure.DepartureTime2);
                if (!arrTime2.isValid()) log.warn("Departure.ArrivalTime2 is not valid:", _this.Departure.ArrivalTime2);

                if (depTime2.isValid() && arrTime2.isValid() && (depTime2.hours() > 0 || depTime2.minutes() > 0 || arrTime2.hours() > 0 || arrTime2.minutes() > 0)) _this.ArrivalTime = _this.Departure.DepartureTime2 + "-" + _this.Departure.ArrivalTime2;
            });

            this.$scope.$watchCollection('$ctrl.selected', function (data) {
                if (data != null) {
                    _this.computePaymentTotals(data);
                }
            });

            this.$scope.$watch('$ctrl.data.selectedReservation.data.Invoices[$ctrl.data.selectedReservation.data.Invoices.length - 1].Amount', function () {
                if (_this.selected != null) {
                    _this.computePaymentTotals(_this.selected);
                }
            });

            this.$scope.$watchCollection(function () {
                return _this.data.Products;
            }, function () {
                _this.hasAccommodations = _.some(_this.data.Products, function (product) {
                    return product.Product.DestinationInfo.ProductType == 'HU' || product.Product.DestinationInfo.ProductType == 'HY' && product.Amount > 0;
                });
                _this.hasExtraServices = _.some(_this.data.Products, function (product) {
                    return product.Product.DestinationInfo.ProductType != 'HU' && product.Product.DestinationInfo.ProductType != 'HY' && product.Amount > 0;
                });
            }, true);

            this.accomodation = false;

            this.checkDiscountCodeVisibility();
        }
    }, {
        key: 'computePaymentTotals',
        value: function computePaymentTotals(data) {
            var _this2 = this;

            this.paidTotal = 0;
            this.unpaidTotal = 0;
            if (!data.data || !data.data.Invoices) {
                log.warn('computePaymentTotals called with incomplete data:', data);
                return;
            }
            _.each(data.data.Invoices, function (inv) {
                //if (inv.State == 'Unpaid') {
                _this2.unpaidTotal += inv.Amount;
                /*}
                else {
                    this.paidTotal += inv.Amount;
                }*/
            });
            if (data.data.Payments) {
                _.each(data.data.Payments, function (paym) {
                    _this2.paidTotal += paym.Amount;
                });
            }
            this.unpaidTotal -= this.paidTotal;
            /*     _.each(data.ExtraServices, (group) => {
                     _.each(group, (product) =>{
                         log(this.unpaidTotal)
                         if (product.Amount){
                             this.unpaidTotal += product.Amount * parseInt(product.Price);
                         }
                     });
                 });*/
        }
    }, {
        key: 'switchToPaymentTab',
        value: function switchToPaymentTab() {
            this.$document.querySelectorAll("a[href='#tab-bd5e28d1-0e77-1']")[0].click();
        }
    }, {
        key: 'isAccomodation',
        value: function isAccomodation() {
            var _this3 = this;

            if (this.accomodation) {
                return true;
            }
            _.each(this.data.Products, function (product) {
                if (product.Product.DestinationInfo.Accommodation) {
                    _this3.accomodation = true;
                    return true;
                } else {
                    _this3.accomodation = false;
                }
            });
            return false;
        }
    }, {
        key: 'getTotal',
        value: function getTotal() {
            // log(this.data)
            var normalPrice = _.sumBy(this.data.Products, function (product) {
                return product.TotalPrice;
            });
            var discounts = _.sumBy(this.data.DiscountProducts, function (product) {
                return product.TotalPrice;
            });
            return normalPrice + discounts; // Discounts have negative prices, so add rather than subtract.
        }
    }, {
        key: 'updateUserOfficeSettings',
        value: function updateUserOfficeSettings() {
            var user = this.userService.getCurrentUser();

            if (user) {
                this.setUserOfficeSettings(user);
            }
        }
    }, {
        key: 'getMessageHeader',
        value: function getMessageHeader() {
            var _this4 = this;

            var language = this.language.charAt(0).toUpperCase() + this.language.slice(1);

            if (this.user) {
                this.summaryInfoHeader = this.user.loginResult.Office.Settings['SummaryInfoHeader' + language];
            } else {
                var user = this.userService.getCurrentUser();
                if (user) {
                    this.user = user;
                    this.summaryInfoHeader = this.user.loginResult.Office.Settings['SummaryInfoHeader' + language];
                }

                this.$rootScope.$on('userDataChanged', function () {
                    _this4.user = _this4.userService.getCurrentUser();
                    _this4.summaryInfoHeader = _this4.user.loginResult.Office.Settings['SummaryInfoHeader' + language];
                });
            }
        }
    }, {
        key: 'checkTravelPackageMessage',
        value: function checkTravelPackageMessage() {
            var _this5 = this;

            this.pending = (0, _winresShoppingCart.checkTravelPackage)(this.messageService, this.cancelService, this.pending, this.data.Products).then(function (travelPackage) {
                _this5.showTravelPackageMessage = travelPackage && travelPackage.TravelPackageInUse;
            });
        }
    }, {
        key: 'checkDiscountCodeVisibility',
        value: function checkDiscountCodeVisibility() {
            var _this6 = this;

            this.$scope.$watch(function () {
                return _this6.userService.getCurrentUser();
            }, function (user) {
                if (user) {
                    // Winres parameter.
                    var discountInUse = user.getParameter('DiscountInUse') === 'TRUE';

                    // Ask for discount code?
                    _this6.$scope.showDiscountCode = discountInUse;

                    // Discount code may already have been applied.
                    _this6.discountCode = _this6.discountService.getDiscountCodeFromLocalStorage();

                    if (_this6.discountCode) {
                        _this6.useDiscountCode();
                    }
                }
            });
        }
    }, {
        key: 'useDiscountCode',
        value: function useDiscountCode() {
            var _this7 = this;

            this.loadingDiscountCode = true;
            this.discountError = null;

            if (this.pending) {
                this.cancelService.cancel(this.pending);
                this.pending = null;
            }

            var code = this.discountCode;

            var request = this.discountService.useDiscountCode(code, this.data.Products, this.data.Passengers);
            this.pending = request;

            request.then(function (discounts) {
                if (discounts == null) {
                    // Canceled.
                    return;
                }

                // Clear exising discount products.
                _this7.discountService.clearDiscountProductsFromCart(_this7.winresReservationContext);

                if (discounts.length > 0) {
                    // Found discounts, add them to shopping cart.

                    _.each(discounts, function (d) {
                        _this7.discountService.addDiscountProductToCart(_this7.winresReservationContext, code, d.Price, d.DestCode, d.ProdCode, d.BeginDate, d.EndDate, d.Name, d.Scope);
                    });

                    // Update discount products for context.
                    _this7.discountService.createDiscountProducts(_this7.winresReservationContext);

                    // Prebook discount code.
                    _this7.data.DiscountCode = code;
                } else {
                    // Discount code was not found, empty discount code and show error pop-up.

                    // Empty discount code field.
                    _this7.discountCode = '';

                    // Empty prebook discount code.
                    _this7.data.DiscountCode = '';

                    if (code) {
                        // We used a discount code and it didn't work.
                        _this7.discountError = _this7.$filter('i18next')('discount.error');
                    } else {
                        // We removed the discount code.
                        // Getting no discounts is expected, so no error.
                        // NOTE: It is still possible to get discounts even without a code,
                        // though I'm not sure if that feature is used anywhere.
                    }
                }
                // this.updateContents();
                _this7.loadingDiscountCode = false;

                // Tell winres-reservation-payment to update the payment options and methods.
                // NOTE: This has to be $rootScope because that component won't be inside this one.
                _this7.$rootScope.$broadcast('updatePaymentMethods');
            });
        }
    }]);

    return WinresReservationSummaryController;
}();

WinresReservationSummaryController.$inject = ['$scope', '$document', '$filter', 'userService', '$rootScope', 'localizationService', 'messageService', 'cancelService', 'discountService'];

function getTemplate($attrs, $sce) {
    if ($attrs.useFancyHtml == "true") {
        return 'reservationSummaryFancy';
    }
    return $attrs.templateUrl ? $sce.trustAsResourceUrl((0, _utils.getWebcomponentsUrl)($attrs.templateUrl)) : 'reservationSummary';
}

getTemplate.$inject = ['$attrs', '$sce'];

_module3.default.run(['$templateCache', function ($templateCache) {
    $templateCache.put('reservationSummary', require('./winresReservationSummary.html'));
    $templateCache.put('reservationSummaryFancy', require('./winresReservationSummaryFancy.html'));
}]);

_module3.default.component('winresReservationSummary', {
    templateUrl: getTemplate,
    controller: WinresReservationSummaryController,
    require: {
        winresReservationContext: '^^winresReservationContext'
    },
    bindings: {
        showExtraServices: '@', // True/false defaults to true
        showAccommodations: '@', // True/false defaults to true
        showNewReservationButton: '@', // True/false defaults to trueh
        showAlways: '@',
        logoUrl: '@',
        showExtraInfoBox: '@',
        showPrice: '@', // True/False defaults to true
        showReservationNumber: '@', // True/False defaults to true
        customerString: '@', // replaces reservation_customer.Customer string
        showNumberOfParticipents: '@', // True/False defaults to true
        showGender: '@', // True/False defaults to true
        thankYouMsg: '@', // replaces reservation_status_codes.Success
        useFancyHtml: '@', // if true (default: false) uses the fancier html file
        useNewStyle: '@', // If true, uses the new-style components for payment option, gift cards, and terms.
        reservation: '@', // changes the text to be reservation instead of departure,
        showArrivalOnHeader: '@',
        messageCode: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresReservationSummary/winresReservationSummary.js
// module id = 401
// module chunks = 2